import React from 'react';
import pro1 from '../img/pro1.jpg';
import pro2 from '../img/pro2.jpg';
import pro3 from '../img/pro3.jpg';
import pro4 from '../img/pro4.jpg';
import pro5 from '../img/pro5.jpg';
import pro6 from '../img/pro6.jpg';
import Footer from '../component/Footer';

const Procedure = () => {
    return (

        <>

<div class="breadcrumb">
                <a href="/">Home</a> / Procedures
            </div>
            <div style={{ padding: '20px', fontFamily: 'Arial, sans-serif' }}>
                {/* Section for Laparoscopic Procedures */}
                <section style={{ marginBottom: '50px' }}>
                    <h1 style={{ textAlign: 'center', color: '#2c3e50' }}>
                        Laparoscopic Keyhole Procedures
                    </h1><br/>
                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '15px' }}>
                        <img
                            src={pro1}
                            alt="Laparoscopic procedure 1"
                            style={{ width: '250px', height: '150px', borderRadius: '10px', objectFit: 'cover' }}
                        />
                        <img
                            src={pro2}
                            alt="Laparoscopic procedure 2"
                            style={{ width: '250px', height: '150px', borderRadius: '10px', objectFit: 'cover' }}
                        />
                        <img
                            src={pro3}
                            alt="Laparoscopic procedure 3"
                            style={{ width: '250px', height: '150px', borderRadius: '10px', objectFit: 'cover' }}
                        />
                        <img
                            src={pro4}
                            alt="Laparoscopic procedure 4"
                            style={{ width: '250px', height: '150px', borderRadius: '10px', objectFit: 'cover' }}
                        />
                    </div>
                </section>

                {/* Section for Andrology Procedures */}
                <section>
                    <h1 style={{ textAlign: 'center', color: '#2c3e50' }}>
                        Andrology Procedures
                    </h1>
                    <p style={{ textAlign: 'center', color: '#7f8c8d' }}>
                        Information related to common male penile procedures
                    </p>
                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', gap: '15px' }}>
                        <img
                            src={pro5}
                            alt="Andrology procedure 1"
                            style={{ width: '250px', height: '150px', borderRadius: '10px', objectFit: 'cover' }}
                        />
                        <img
                            src={pro6}
                            alt="Andrology procedure 2"
                            style={{ width: '250px', height: '150px', borderRadius: '10px', objectFit: 'cover' }}
                        />
                    </div>
                </section>
            </div>

            <Footer />


        </>
    );
};

export default Procedure;
